module.exports = "/_next/static/images/OctoDiagram-lg-a840cdf00838f8fe1641488cbfe2c860.png";